import React from 'react';
import AdminManageBaseRentValidationRules from './admin-manage-base-rent-validation-rules';
import AdminManageLeaseValidationRules from './admin-manage-lease-validation-rules';
import Accordion from '../../components/accordion/accordion';

// Nested sub-tabs within the single "Validation Rules" admin section.
const validationRulesSections = [
  {
    title: 'Base Rent Validation',
    content: <AdminManageBaseRentValidationRules />,
  },
  {
    title: 'All Lease Validations',
    content: <AdminManageLeaseValidationRules />,
  },
];

const AdminManageValidationRules = () => {
  return <Accordion sections={validationRulesSections} />;
};

export default AdminManageValidationRules;
